import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js"
import { Signals } from "@/Imports";
import Facade from "@/Facade";
import FormatData from "@/application/FormatData";
import UIConfig from "@baseUI/config/UIConfig";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import AddComponent from "@base/utils/AddComponent";
import {GlowFilter} from "@pixi/filter-glow";
import gsap from "gsap";
import UIFacade from "../../pixiUISimpleLibrary/UIFacade";

export default class FreespinsOutroContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {

    const addElementBitmapText = AddComponent.addElementBitmapText
    const bigCaptionStyle = {font: {name: 'fontWin', size: '120px'}, align: 'center'}
    const smallCaptionStyle = {
      font: {
        name: 'fontWin',
        size: '180px',
      },
      align: 'center'
    }

    const shadow = new PIXI.Graphics()
    shadow.name = 'graphics #16';
    shadow.interactive = true
    shadow.beginFill(0x000000, 0.6)
    shadow.drawRect(-UIConfig.totalWidth / 2, -2000, 5000, 5000)
    this.addChildAt(shadow, 0)

    this.popuWin = new SpineAnimation('lower_win_message')
    this.popuWin.start(['freespins_low_win_start', 'freespins_low_idle'], [false, true])
    this.popuWin.x = 0
    this.popuWin.y = -150
    this.popuWin.scale.set(1.25);
    this.addChild(this.popuWin)

    this.container = new PIXI.Container()
    this.addChild(this.container)
    this.container.y = 60;

    this.ContinueButton = new PIXI.AnimatedSprite([
      PIXI.Texture.from('freeSpin/BackToGameButtonNormal'),
      PIXI.Texture.from('freeSpin/BackToGameButtonOver'),
      PIXI.Texture.from('freeSpin/BackToGameButtonDown')]
    )
    this.ContinueButton.anchor.set(0.5)
    this.ContinueButton.y = 190
    this.container.addChild(this.ContinueButton)
    this.ContinueButton.on('pointerover', () => {
      this.ContinueButton.gotoAndStop(1)
    })

    this.ContinueButton.on('pointerout', () => {
      this.ContinueButton.gotoAndStop(0)
    })
    AddComponent.addElementTextName('backToGame', this.ContinueButton, [0, 0]) //'freeSpinButton',

   const filters = new GlowFilter({ distance: 10, outerStrength: 2, color: 0x000000})

   // const board = AddComponent.addElementSettings('freeSpin/win_board', this.container, {x:-300, y:-170})
   // AddComponent.addElementTextName('maxWin', 'splashScreenYellow', board, [300, 50])
    this.textBoardWin = addElementBitmapText('',smallCaptionStyle, this.container, [-30, -100], filters)

    // this.popupFreespinsTotalWinningsText = new LocalizedPIXIText('0', Facade.textFactory.getStyle('freeSpinValue'))
    // this.popupFreespinsTotalWinningsText.style.align = 'left'
    // this.popupFreespinsTotalWinningsText.anchor.set(0.5)
    // this.popupFreespinsTotalWinningsText.position.set(0, 50)
    // this.container.addChild(this.popupFreespinsTotalWinningsText)

   // AddComponent.addElementText('totalWin', 'youHaveWon', this,[0, -180]);



    // this.totalWinText = addElementBitmapText('',bigCaptionStyle, this, [0,-180], filters)
    // this.freeSpinsText = addElementBitmapText('',bigCaptionStyle, this, [0, 150], filters)
    // this.countText = addElementBitmapText('',bigCaptionStyle, this, [0, 40], filters)

    // this.totalWinText.text = Facade.textFactory.getStringByIdentifier()
    // this.freeSpinsText.text = Facade.textFactory.getStringByIdentifier('freeSpins')


    Signals.outroFreespins.add(this.showFreespinsOutro, this)
    //Signals.introFreespins.add(this.showFreespinsOutro, this)
    this.hide()
  }

  showFreespinsOutro() {
    this.visible = true
    Facade.model.coinsRaceFS = 0
    this.textBoardWin.text = Facade.model.winCurrencyFreespins.toFixed(2)//UIFacade.model.scoreWin;


    this.ContinueButton.interactive = true
    this.ContinueButton.once('pointerdown', this.showFreespinsOutroComplete.bind(this))

   // Facade.soundManager.play('gch_popup_winnings', 1, false, 'default')
    gsap.delayedCall(5, () => {
      this.showFreespinsOutroComplete()
    })
  }

  hide() {
    this.visible = false
  }

  showFreespinsOutroComplete() {
    this.hide()
    this.ContinueButton.gotoAndStop(2)
    this.ContinueButton.interactive = false
    Signals.outroFreespinsComplete.dispatch()
  }

}
